import { FormattedMessage } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import SearchSupport from './SearchSupport'

const HeroTextBlock = () => {
  return (
    <Stack
      direction="column"
      spacing={4}
      sx={{
        alignItems: 'center',
        width: 490,
        justifyContent: 'flex-end',
        mb: 2
      }}
    >
      <Stack direction="column" spacing={1} sx={{ textAlign: 'center' }}>
        <Text variant="h1" size={{ xs: 'h2', sm: 'h1' }}>
          <FormattedMessage defaultMessage="Pit Stop for Assistance" />
        </Text>

        <Text
          variant="body1"
          sx={{ color: 'text.third', width: { xs: 329, sm: '100%' } }}
        >
          <FormattedMessage defaultMessage="Get answers and explore the new ways to use ifnd" />
        </Text>
      </Stack>

      <SearchSupport />
    </Stack>
  )
}

export default HeroTextBlock
